(ns renolit-roofing-service.view.service-view
  (:require [dev.gethop.session.re-frame.cognito.token :as session.token]
            [malli.util :as mu]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [renolit-roofing-service.layout.components :refer [back-link-history]]
            [renolit-roofing-service.localization :refer [t]]
            [renolit-roofing-service.navigation :as nav]
            [renolit-roofing-service.util :as util]
            [renolit-roofing-service.util.google-maps :as google-maps]
            [renolit-roofing-service.view :as view]
            [renolit-roofing-service.view.service.service-information-view :as view.service-information]
            [renolit-roofing-service.view.service.zone-view :as view.service.zone]
            [renolit-roofing-service.view.service.visit-program-view :as view.service.visit-program]
            [renolit-roofing-service.view.laboratory-report-summary :as view.report-summary-view]
            [renolit-roofing-service.view.installer-service-information.zone :as view.report-summary-zone]))

(def path-params-schema
  [:map
   [:service-id :uuid]])

(def ^:const route-config
  {:name [:service-details]
   :auth-req? true
   :parameters {:path path-params-schema}
   :controllers [{:parameters {:path (mu/keys path-params-schema)}
                  :start #(rf/dispatch [::view.on-enter %])
                  :stop #(rf/dispatch [::view.on-leave %])}]})

(rf/reg-event-fx
 ::view.on-enter
 (fn [{:keys [db]} [_ {{:keys [service-id]} :path}]]
   {:db (assoc db :gmaps/read-only? true)
    :fx [[:dispatch [::load-service service-id]]]}))

(rf/reg-event-fx
 ::view.on-leave
 (fn [{:keys [db]} _]
   {:db (-> db
            (dissoc :service-details/service
                    :service-details/project
                    :lab-report-summary/conclusions
                    :gmaps/bridge-registry
                    :gmaps/read-only?
                    :zones
                    :zones-bounds
                    :default-map-viewport))}))

(defn transform-zones-to-gmap-zones
  [{:keys [zones reviews]}]
  (let [zone-nodes (->> zones
                        (mapv (fn [{:keys [id name area subzones]}]
                                #:zone{:id id
                                       :name name
                                       :polygon area
                                       :subzones (set subzones)
                                       :pois (->> reviews
                                                  (filter #(= (:zone-id %) id))
                                                  (map :id)
                                                  (set))
                                       :parent-zone-id (->> zones
                                                            (filter #(contains? (:subzones %) id))
                                                            (map :id)
                                                            (first))})))
        poi-nodes (->> reviews
                       (mapv (fn [{:keys [id type zone-id lat-lng wp wp-type tasks]}]
                               #:poi{:id id
                                     :type (-> type
                                               (name)
                                               (str "-revision")
                                               (keyword))
                                     :parent-zone-id zone-id
                                     :marker lat-lng
                                     :work-package {:wp wp
                                                    :wp-type wp-type
                                                    :tasks tasks}})))]
    (into zone-nodes poi-nodes)))

(rf/reg-event-fx
 ::load-service-success
 (fn [{:keys [db]} [_ {:keys [service]}]]
   {:db (assoc db
               :service-details/service service
               :current-service service
               :lab-report-summary/conclusions (:conclusions service))
    :fx [[:dispatch [::google-maps/initialize-zones (transform-zones-to-gmap-zones service)]]
         [:dispatch [::load-project (:project-id service)]]]}))

(rf/reg-event-fx
 ::load-service
 [(rf/inject-cofx ::session.token/session)]
 (fn [{:keys [session]} [_ service-id]]
   {:http-xhrio
    {:headers {"Authorization" (str "Bearer " (get-in session [:id-token :jwt]))}
     :method :get
     :uri (str "/api/services/" service-id)
     :params {}
     :response-format (util/ajax-transit-response-format)
     :on-success [::load-service-success]
     :on-failure [::util/generic-error]}}))

(rf/reg-event-fx
 ::load-project
 [(rf/inject-cofx ::session.token/session)]
 (fn [{:keys [session]} [_ project-id]]
   {:http-xhrio {:headers {"Authorization" (str "Bearer " (get-in session [:id-token :jwt]))}
                 :method :get
                 :uri (str "/api/projects/" project-id)
                 :response-format (util/ajax-transit-response-format)
                 :on-success [::load-project-success]
                 :on-failure [::util/generic-error]}}))

(rf/reg-event-fx
 ::load-project-success
 (fn [{:keys [db]} [_ {:keys [project]}]]
   {:db (assoc db :service-details/project project)}))

(rf/reg-sub
 ::get-service-data
 (fn [db _]
   (get db :service-details/service)))

(rf/reg-sub
 ::get-project-data
 (fn [db _]
   (get db :service-details/project)))

(defn- main
  []
  (let [tab (r/atom :service-information)]
    (fn []
      (let [service @(rf/subscribe [::get-service-data])
            project @(rf/subscribe [::get-project-data])
            project-id (:project-id service)]
        (when service
          [:div.user_layout
           [:div.user_layout_header
            [back-link-history (t [:common.go-back])]]
           [:div.project
            [:div.project_title-bar
             [:h1.user_layout_header_title (t [:page.service.add.title]) " " [:span.color-gray "(" (t [:common.project]) " " (str project-id) ")"]]]
            [:div.tabs
             [:div.tab
              {:class (when (#{:service-information} @tab) "active")
               :on-click #(reset! tab :service-information)}
              (t [:common.service-information])]
             [:div.tab
              {:class (when (#{:zones} @tab) "active")
               :on-click #(reset! tab :zones)}
              (t [:common.zones])]
             [:div.tab
              {:class (when (#{:visit-program} @tab) "active")
               :on-click #(reset! tab :visit-program)}
              (t [:common.visit-program])]
             (when (= (:status service) "diagnosis-closed")
               [:div.tab
                {:class (when (#{:final-report} @tab) "active")
                 :on-click #(do
                              (reset! tab :final-report)
                              (rf/dispatch [::view.report-summary-zone/initialize-zones-map]))}
                (t [:common.final-report])])]
            (case @tab
              :service-information
              [view.service-information/main service]
              :zones
              [view.service.zone/main service project]
              :visit-program
              [view.service.visit-program/main service]
              :final-report
              [view.report-summary-view/main-view (r/atom service) (r/atom project)])]])))))

(defmethod view/view-display (:name route-config)
  [{:keys [_parameters]}]
  [main])
